import { createContext, useContext } from 'react';

export type OnboardingFlowState =
  | 'idle'
  | 'welcome'
  | 'running'
  | 'paused'
  | 'finishing';

export interface OnboardingContextValue {
  flowState: OnboardingFlowState;
  hasCompleted: boolean;
  pillDismissed: boolean;
  isReady: boolean;
  isMobile: boolean;
  tourStepIndex: number;
  suppressResumeToast: boolean;
  start: () => void;
  beginTour: () => void;
  finishTour: () => void;
  skip: () => void;
  restart: () => void;
  requestReplayTour: () => void;
  dismissPill: () => void;
  setTourStepIndex: (index: number) => void;
  pauseTour: () => void;
  resumeTour: (nextStepIndex?: number) => void;
  setSuppressResumeToast: (suppress: boolean) => void;
}

export const OnboardingContext = createContext<OnboardingContextValue | null>(
  null,
);

export const useOnboarding = (): OnboardingContextValue => {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    throw new Error(
      'useOnboarding must be used within an <OnboardingProvider>',
    );
  }
  return ctx;
};
